var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"bannerbox"},[_c('el-carousel',{attrs:{"height":_vm.bannerHeight + 'px'}},_vm._l((_vm.bannerlist),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{attrs:{"src":item.url,"alt":""}})])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }